<template>
  <v-container fluid>
    <v-row v-if="singleLine" align="center" dense>
      <v-col cols="6" md="2">
        <v-text-field
          v-model="searchValue"
          required
          v-on:keyup="searchValueKeyUp"
          :loading="loading"
        >
          <template v-slot:label> Buscar por {{ searchField }} </template>
          <template v-slot:append>
            <v-icon @click="search">search</v-icon>
          </template>
        </v-text-field>
      </v-col>

      <v-col>
        <v-btn-toggle v-model="searchField" mandatory>
          <v-btn color="success" small text value="Documento">Documento</v-btn>
          <v-btn color="info" small text value="Cuil">CUI(L/T)</v-btn>
          <v-btn color="error" small text value="Nombre">Nombre</v-btn>
          <v-btn color="warning" small text value="Operacion">Nº Crédito</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row v-else align="center" dense>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-btn-toggle v-model="searchField" mandatory>
              <v-btn color="success" small text value="Documento"
                >Documento</v-btn
              >
              <v-btn color="info" small text value="Cuil">CUI(L/T)</v-btn>
              <v-btn color="error" small text value="Nombre">Nombre</v-btn>
              <v-btn color="warning" small text value="Operacion"
                >Nº Crédito</v-btn
              >
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="2">
            <v-text-field
              v-model="searchValue"
              required
              v-on:keyup="searchValueKeyUp"
              :loading="loading"
            >
              <template v-slot:label> Buscar por {{ searchField }} </template>
              <template v-slot:append>
                <v-icon @click="search">search</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-row>

    <v-dialog v-model="showResultadosBusqueda" width="1000">
      <v-list three-line>
        <template v-for="(item, index) in searchResults">
          <v-subheader v-if="item.header" :key="item.header">
            {{ item.header }}
          </v-subheader>
          <v-divider
            v-else-if="item.divider"
            :inset="item.inset"
            :key="index"
          ></v-divider>

          <v-list-item v-else :key="item.personaId" @click="setPersona(item)">
            <v-list-item-avatar>
              <v-speed-dial
                fab
                direction="right"
                open-on-hover
                transition="slide-y-reverse-transition"
                top
              >
                <template v-slot:activator>
                  <v-btn fab small icon>
                    <v-icon v-if="item.avatar == 'domain'" medium color="grey"
                      >domain</v-icon
                    >
                    <v-icon x-large v-else medium color="orange"
                      >touch_app</v-icon
                    >
                  </v-btn>
                </template>
              </v-speed-dial>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-html="item.title"></v-list-item-title>
              <v-list-item-subtitle
                class="caption"
                v-html="item.subtitle"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="pagination.page"
          :length="pages"
          :total-visible="5"
          circle
        ></v-pagination>
        <p></p>
      </div>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from 'vue';
import { http } from '@/axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    loading: false,
    searchField: '',
    searchValue: '',
    pagination: {
      // definición de paginación
      descending: false,
      page: 1,
      rowsPerPage: 5,
      sortBy: '',
      rowsPerPageItems: [5, 10, 15, 20, 50],
    },
    items: [],
    totalItems: 0,
    searchResults: [],
    showResultadosBusqueda: false,
  }),
  props: {
    singleLine: {
      type: Boolean,
      default: true,
    },
    personaSeleccionada: {
      type: Function,
    },
  },
  created() {
    this.searchField = this.UiCustomUserSettings.busquedaPersonaPor;
  },
  watch: {
    pagination: {
      handler() {
        this.search();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'UiCustomUserSettings', 'DebugModeOn']),
    pages() {
      if (this.pagination.rowsPerPage == null || this.totalItems == null)
        return 0;

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    searchValueKeyUp: function (e) {
      if (e.keyCode === 13) {
        this.search();
      }
    },
    setPersona(persona) {
      //this.selectedPersona = persona;
      //this.personaId = persona.personaId;

      if (this.personaSeleccionada != null) this.personaSeleccionada(persona);

      this.showResultadosBusqueda = false;
    },
    async search() {
      try {
        if (this.searchValue == '') {
          this.alertWarning(
            'Por favor, ingrese un ' + this.searchField + ' a buscar.'
          );
          return;
        }

        this.selectedPersona = null;

        // valido el dato a buscar en base a qué se busca
        if (this.searchField == 'Documento') {
          if (isNaN(this.searchValue)) {
            const res = await this.$dialog.confirm({
              text: 'Estás consultando por Documento, pero no ingresaste un número válido, ¿puede ser que hayas querido buscar por Nombre?',
              title: 'Atención',
              persistent: true, // Parece que no funciona...
            });

            if (!res) {
              return;
            } else {
              this.searchField = 'Nombre';
            }
          }
        } else if (this.searchField == 'Cuil') {
          if (isNaN(this.searchValue)) {
            const res = await this.$dialog.confirm({
              text: 'Estás consultando por Cuil, pero no ingresaste un número válido, ¿puede ser que hayas querido buscar por Nombre?',
              title: 'Atención',
              persistent: true, // Parece que no funciona...
            });

            if (!res) {
              return;
            } else {
              this.searchField = 'Nombre';
            }
          } else {
            if (this.searchValue.length != 11) {
              this.alertWarning(
                'Por favor, ingrese los 11 dígitos del Cuil o  Cuit.'
              );
              return;
            }
          }
        } else if (this.searchField == 'Nombre') {
          if (!isNaN(this.searchValue)) {
            // está buscando x nombre, pero ingresó un número
            if (this.searchValue.length == 8) {
              // veo si no quiso poner un documento de identidad
              const res = await this.$dialog.confirm({
                text: 'Estás consultando por Nombre, pero pusiste todos números, ¿puede ser que hayas querido buscar por Documento?',
                title: 'Atención',
                persistent: true, // Parece que no funciona...
              });

              if (!res) {
                return;
              } else {
                this.searchField = 'Documento';
              }
            }
          }
        }

        this.loading = true;

        var searchApi = '';
        switch (this.searchField) {
          case 'Documento':
            searchApi =
              'personas/listapordocumento?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&documento=';
            break;
          case 'Cuil':
            searchApi =
              'personas/listaporcui?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&cui=';
            break;
          case 'Nombre':
            searchApi =
              'personas/listapornombre?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&nombre=';
            break;
          case 'Operacion':
            searchApi =
              'personas/listapornumerocredito?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&numeroCredito=';
            break;
        }

        var result = await http.get(searchApi + this.searchValue); // traigo todas

        this.items = result.list;
        this.totalItems = result.totalCount;

        // limpio la lista
        this.searchResults = [];

        this.searchResults.push({ header: 'Resultados' });

        if (this.totalItems == 1) {
          // si hay uno, lo seteo directamente
          const element = this.items[0];

          if (element.tipoPersonaId == 1) {
            //Persona Física
            this.searchResults.push({
              avatar: '',
              title: element.nombreCompleto,
              nombreCompleto: element.nombreCompleto,
              cui: element.cui,
              personaId: element.id,
              viewLegajo: '/legajo-persona/' + element.id,
              subtitle:
                "<span class='text--primary'>" +
                element.documentoCompleto +
                '</span> &mdash; ' +
                element.situacion,
              masInfo: element.situacion,
              alertas: element.alertasFull,
              enListaNegra: element.avisos.includes('Lista negra'),
            });
          } else {
            //Persona Jurídica
            this.searchResults.push({
              avatar: 'domain',
              title: element.nombre,
              nombreCompleto: element.nombreCompleto,
              cui: element.cui,
              personaId: element.id,
              viewLegajo: '/legajo-persona-juridica/' + element.id,
              subtitle:
                "<span class='text--primary'>" +
                'CUIT: ' +
                element.cui +
                '</span> &mdash; ' +
                element.situacion,
              masInfo: element.situacion,
              alertas: element.alertasFull,
              enListaNegra: element.avisos.includes('Lista negra'),
            });
          }

          this.setPersona(this.searchResults[1]);
        } else if (this.totalItems == 0) {
          // avisar que no se encontró
          this.alertWarning(
            'No se encontraron registros con los datos ingresados.'
          );
          this.isVisible = false;
        } else {
          // transformo el resutado en items para la lista
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];

            if (element.tipoPersonaId == 1) {
              //Persona Física
              this.searchResults.push({
                avatar: '',
                title: element.nombreCompleto,
                nombreCompleto: element.nombreCompleto,
                cui: element.cui,
                personaId: element.id,
                viewLegajo: '/legajo-persona/' + element.id,
                subtitle:
                  "<span class='text--primary'>" +
                  element.documentoCompleto +
                  '</span> &mdash; ' +
                  element.situacion,
                masInfo: element.situacion,
                alertas: element.alertasFull,
                enListaNegra: element.avisos.includes('Lista negra'),
              });
            } else {
              //Persona Jurídica
              this.searchResults.push({
                avatar: 'domain',
                title: element.nombre,
                nombreCompleto: element.nombreCompleto,
                cui: element.cui,
                personaId: element.id,
                viewLegajo: '/legajo-persona-juridica/' + element.id,
                subtitle:
                  "<span class='text--primary'>" +
                  'CUIT: ' +
                  element.cui +
                  '</span> &mdash; ' +
                  element.situacion,
                masInfo: element.situacion,
                alertas: element.alertasFull,
                enListaNegra: element.avisos.includes('Lista negra'),
              });
            }

            this.searchResults.push({ divider: true, insert: true });

            this.showResultadosBusqueda = true;
          }
        }
      } catch (error) {
        // Error
        this.alertWarning(error);
      }

      this.loading = false;
    },
  },
};
</script>
